// Where the stage draws right now, as hooks (state.ts has the pure rule). components/Stage.tsx's PlayerOverlay asks
// useStageCovers() so a clip the Director plays shows on the stage instead of over it.
import { useEffect, useState } from "react";
import { useStore } from "../store";
import { stageSurface, type StageSurface } from "./state";

export const DESKTOP = "(min-width: 1024px)";

export function useDesktop() {
  const [on, setOn] = useState(() => typeof window !== "undefined" && !!window.matchMedia?.(DESKTOP).matches);
  useEffect(() => {
    const m = window.matchMedia?.(DESKTOP);
    if (!m) return;
    const f = () => setOn(m.matches);
    m.addEventListener("change", f);
    return () => m.removeEventListener("change", f);
  }, []);
  return on;
}

export function useStageSurface(): StageSurface {
  const desktop = useDesktop();
  const stage = useStore((s) => s.stage);
  const suiteProject = useStore((s) => s.suiteProject);
  return stageSurface(stage, { desktop, suiteProject });
}

/** The stage is up as the overlay (the playback overlay steps aside; the stage plays it itself). */
export const useStageCovers = () => useStageSurface() === "overlay";
